import * as React from 'react'

import { MediumIcon } from '@factorialco/deprecated-design-system'
import { BookkeeperCompanyIncidenceOptionFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { useGetIncidenceSettings } from 'modules/bookkeepers/hooks/useGetIncidenceSettings'
import { IncidenceOptionsType } from 'modules/bookkeepers/lib/incidenceOptions'

export const SECTION_NAMES = {
  personal_updates: 'personal_updates',
  default_updates: 'default_updates',
  absence_updates: 'absence_updates',
  payroll_data_updates: 'payroll_data_updates',
}

export interface IncidenceOptionSection {
  id: string
  title: string
  icon: MediumIcon
  sectionReference: React.RefObject<HTMLElement>
  incidenceOptions: IncidenceOptionsType[]
}

export interface IncidenceOptionsData {
  loading: boolean
  incidenceOptionSections: IncidenceOptionSection[]
  companyIncidenceSettings: BookkeeperCompanyIncidenceOptionFragment[]
}

const personalUpdatesSection = (
  employeeIncidenceOptions: IncidenceOptionsType[]
): IncidenceOptionSection => {
  return {
    id: SECTION_NAMES.personal_updates,
    title: i18n.t(
      'app_store_v2.apps.payroll_bundle.settings.incidences.sections.personal_data_updates'
    ),
    icon: 'user',
    sectionReference: React.createRef(),
    incidenceOptions: employeeIncidenceOptions,
  }
}

const defaultUpdatesSection = (
  contractIncidenceOptions: IncidenceOptionsType[]
): IncidenceOptionSection => {
  return {
    id: SECTION_NAMES.default_updates,
    title: i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.sections.default_updates'),
    icon: 'globe',
    sectionReference: React.createRef(),
    incidenceOptions: contractIncidenceOptions,
  }
}

const absenceUpdatesSection = (
  leaveIncidenceOptions: IncidenceOptionsType[]
): IncidenceOptionSection => {
  return {
    id: SECTION_NAMES.absence_updates,
    title: i18n.t('app_store_v2.apps.payroll_bundle.settings.incidences.sections.absence_updates'),
    icon: 'calendar',
    sectionReference: React.createRef(),
    incidenceOptions: leaveIncidenceOptions,
  }
}

const payrollDataUpdatesSection = (
  payrollDataIncidenceOptions: IncidenceOptionsType[]
): IncidenceOptionSection => {
  return {
    id: SECTION_NAMES.payroll_data_updates,
    title: i18n.t(
      'app_store_v2.apps.payroll_bundle.settings.incidences.sections.payroll_data_updates'
    ),
    icon: 'payroll',
    sectionReference: React.createRef(),
    incidenceOptions: payrollDataIncidenceOptions,
  }
}

export const useIncidenceOptionSections = (
  companyId: string,
  bookkeeperView = false
): IncidenceOptionsData => {
  const {
    loading,
    employeeIncidenceOptions,
    defaultIncidenceOptions,
    leaveIncidenceOptions,
    companyIncidenceSettings,
    payrollDataIncidenceOptions,
  } = useGetIncidenceSettings(companyId, bookkeeperView)

  const incidenceOptionSections = [
    defaultUpdatesSection(defaultIncidenceOptions),
    personalUpdatesSection(employeeIncidenceOptions),
    absenceUpdatesSection(leaveIncidenceOptions),
    payrollDataUpdatesSection(payrollDataIncidenceOptions), //TODO: under FF
  ]

  return { loading, companyIncidenceSettings, incidenceOptionSections }
}
